import userApis from "../../api/user";

const state = () => ({
  userInfo: {},
});

const userModule = {
  namespaced: true,
  state: state,
  mutations: {
    SET_USER_INFORMATION: (state, payload) => (state.userInfo = payload),
  },
  actions: {
    //   get user information
    async getUserInfo({ dispatch, commit }, payload) {
        const { data } = await userApis.getUserInfo(`?include=photo,default_store,shop`);
        await commit("SET_USER_INFORMATION", data.data);
    },
  }
};

export default userModule;